import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from './plugins/axios'
import config from './config'
import { i18n } from './plugins/i18n.js'

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

//axios.defaults.baseURL = config.apiUrl;
Vue.prototype.axios = axios;
Vue.config.productionTip = false;
import CKEditor from 'ckeditor4-vue';
import VueFirestore from 'vue-firestore';

Vue.use( CKEditor, Datetime );
Vue.use(VueFirestore);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');

i18n.locale = 'la'
